/**
 * React Query хуки для runtime-карточки объекта.
 */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { objectCardApi } from "@/services/card-api.service";
import type {
  ObjectCardResponse,
  ObjectCardUpdateRequest,
} from "@/types/card-template";

export function useObjectCard(
  objectId: number | null | undefined,
  options?: { enabled?: boolean }
) {
  const enabled =
    (options?.enabled !== false) &&
    !!objectId &&
    objectId > 0;
  return useQuery<ObjectCardResponse>({
    queryKey: ["object-card", objectId],
    queryFn: () => objectCardApi.getCard(objectId!),
    enabled,
    staleTime: 60_000,
  });
}

export function useUpdateObjectCard(objectId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ObjectCardUpdateRequest) => {
      if (!objectId || objectId <= 0) {
        return Promise.reject(new Error("Некорректный ID объекта"));
      }
      return objectCardApi.updateCard(objectId, payload);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(["object-card", objectId], data);
      queryClient.invalidateQueries({ queryKey: ["objects", objectId] });
      queryClient.invalidateQueries({
        predicate: (q) =>
          Array.isArray(q.queryKey) && q.queryKey[0] === "geometry-audit",
      });
      queryClient.invalidateQueries({ queryKey: ["object-card-audit", objectId] });
    },
  });
}
